export const MAX_RECORDING_SECONDS = 60;

export const formatRecordingTime = (seconds: number) => {
  const safe = Math.max(0, Math.min(MAX_RECORDING_SECONDS, Math.floor(seconds)));
  const minutes = Math.floor(safe / 60);
  const rest = safe % 60;
  return `${minutes.toString().padStart(2, "0")}:${rest.toString().padStart(2, "0")}`;
};
